import { Deserializable } from '../protocols/deserializable';
import { ContributionTypeEnum } from '../../features/new-contribution/enums/contribution-type.enum';
import { MemberContributionFrequencyEnum } from '../enum/shared/member-contribution-frequency-enum';
import { MemberContributionType } from '../types/dto/member-contribution-type';
import { MemberContributionFrequencyType } from '../types/dto/member-contribution-frequency-type';

export class PaymentMethodScheduledContributionUsage implements Deserializable {
  public id!: number;
  public name!: string;
  public amount!: number;
  public frequencyId!: MemberContributionFrequencyEnum;
  public frequency!: MemberContributionFrequencyType;
  public contributionTypeId!: ContributionTypeEnum;
  public contributionType!: MemberContributionType;
  public spouseId!: number | null;

  onDeserialize(): void {
    const Deserialize = window?.injector?.Deserialize;
    if (this.frequency) {
      this.frequency = Deserialize?.instanceOf(MemberContributionFrequencyType, this.frequency);
    }

    if (this.contributionType) {
      this.contributionType = Deserialize?.instanceOf(MemberContributionType, this.contributionType);
    }
  }
}
